import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { useCartState } from '../cart-provider';

export const useCartContext = () => {
  const [cartState, setCartState] = useCartState();
  const isDiagnosticsEnabled = useFlag(LaunchDarklyFlag.ENABLE_INTERNAL_DIAGNOSTIC_TOOLS);
  const { cartEntries } = useMinimalCart();

  return { ...cartState, setCartState, isDiagnosticsEnabled, cartEntries };
};
